const typedEl = document.querySelector(".banner__title-typing");
let textsData = typedEl?.dataset.subtitle;

const typingDelay = 150;
const erasingDelay = 40;
const startWrittingDelay = 100;
const newTextDelay = 2500;

if (textsData) {
  textsData = textsData.split(",");
  const texts = textsData.filter((el) => el != "");

  let textIndex = 0; //index of the word, text array index
  let letterIndex = 0; //letterIndex of the letter

  function type() {
    if (letterIndex < texts[textIndex].length) {
      typedEl.textContent += texts[textIndex].charAt(letterIndex);
      letterIndex++;
      setTimeout(type, typingDelay);
    } else if (textIndex !== texts.length - 1) {
      setTimeout(erase, newTextDelay);
    } else {
      setTimeout(removeClass, newTextDelay);
    }
  }

  function removeClass() {
    typedEl.classList.remove("animations__typing-cursor");
  }

  function erase() {
    if (letterIndex > 0) {
      typedEl.textContent = texts[textIndex].substring(0, letterIndex - 1);
      letterIndex--;
      setTimeout(erase, erasingDelay);
    } else {
      textIndex++;
      setTimeout(type, typingDelay + 1100);
    }
  }

  if (texts.length) {
    document.addEventListener("DOMContentLoaded", () =>
      setTimeout(type, startWrittingDelay)
    );
  }
}
